const normalizeAmex = value => {
  if (value.length <= 4) {
    return value;
  }
  if (value.length <= 10) {
    return `${value.slice(0, 4)} ${value.slice(4)}`;
  } else if (value.length <= 15) {
    return `${value.slice(0, 4)} ${value.slice(4, 10)} ${value.slice(10)}`;
  } else {
    return `${value.slice(0, 4)} ${value.slice(4, 10)} ${value.slice(10, 15)}`;
  }
};

const normalize4x4 = value => {
  if (value.length <= 4) {
    return value;
  }
  if (value.length <= 8) {
    return `${value.slice(0, 4)} ${value.slice(4)}`;
  } else if (value.length <= 12) {
    return `${value.slice(0, 4)} ${value.slice(4, 8)} ${value.slice(8)}`;
  } else if (value.length <= 16) {
    return `${value.slice(0, 4)} ${value.slice(4, 8)} ${value.slice(8, 12)} ${value.slice(12)}`;
  } else {
    return `${value.slice(0, 4)} ${value.slice(4, 8)} ${value.slice(8, 12)} ${value.slice(12, 16)}`;
  }
};

const normalizeCreditCardNumber = value => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  if (/^3[47]/.test(onlyNums)) {
    return normalizeAmex(onlyNums);
  } else {
    return normalize4x4(onlyNums);
  }
};

export default normalizeCreditCardNumber;



// WEBPACK FOOTER //
// ./src/common/forms/normalizers/creditCardNumber.js